var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsights4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8224 4.65883C33.0341 2.83844 36.9659 2.83844 40.1776 4.65883L49.4749 9.92858L58.6874 15.3455C61.8698 17.2167 63.8357 20.6217 63.865 24.3133L63.9499 35L63.865 45.6867C63.8357 49.3783 61.8698 52.7833 58.6874 54.6545L49.475 60.0714L40.1776 65.3412C36.9659 67.1616 33.0341 67.1616 29.8224 65.3412L20.5249 60.0713L11.3125 54.6545C8.13021 52.7833 6.16434 49.3783 6.135 45.6867L6.05005 35L6.135 24.3133C6.16434 20.6217 8.13021 17.2167 11.3126 15.3455L20.525 9.92861L29.8224 4.65883Z",
    fill: "#17233B",
    stroke: "#EDFF6B",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40V31M33 40V33M37 40V37M41 40V31M26 43H44C44.5523 43 45 42.5523 45 42V28C45 27.4477 44.5523 27 44 27H26C25.4477 27 25 27.4477 25 28V42C25 42.5523 25.4477 43 26 43Z",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights4);
export default __webpack_public_path__ + "static/media/insights4.923c6a8d4eb86a387c458a88ec7ed47c.svg";
export { ForwardRef as ReactComponent };